import { debugMode } from './config';

export default (message, level = 'log') => {
	if (debugMode) {
		console[level]('@i18n: ', message);
	}
};
